/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from '../../mutation-types';

const state = {
  product: {
    zones: [],
    partners: [],
  },
  coordinates: [],
  error: null,
};

const getters = {
  product: state => state.product,
  coordinates: state => state.coordinates,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    const tenant = payload.user.data.selectedRole.role === 'landlord' ? payload.id : payload.user.data.selectedRole.id;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/partners/${tenant}/products/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  add({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.post(
      `${process.env.BACKEND_API_URL}api/${path}/partners/${payload.tenant_id}/products/${payload.product_id}`,
      {
        product_id: payload.product_id,
        amount: payload.amount,
      })
      .then(() => {
      }).catch((response) => {
        commit(mTypes.DATA_ERROR, response.body.message);
      });
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/partners/${payload.tenant_id}/products/${payload.product_id}`,
      {
        product_id: payload.product_id,
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response.body.message);
      });
  },
  edit({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.put(
      `${process.env.BACKEND_API_URL}api/${path}/partners/${payload.companyId}/products/${payload.productId}`, {
      amount: payload.amount,
      pool_parking: payload.pool_parking,
      tenant_pays_pp: payload.tenant_pays_pp,
    })
      .catch((response) => {
        if (response.data) {
          const errorMessage = response.data.message;
          if (errorMessage) {
            return commit(mTypes.DATA_ERROR, response.data.message);
          }
        }

        return commit(mTypes.DATA_ERROR, response.body.message);
      });
  },

};

const mutations = {
  [mTypes.DATA_FETCHED](state, product) {
    state.product = product.data;
    state.coordinates = [];
    if (state.product.zones) {
      state.product.zones.forEach((el) => {
        if (el.coordinates) {
          state.coordinates.push(el.coordinates);
        }
      });
    }
    state.error = null;
  },
  [mTypes.CLEAR_STATE](state) {
    state.product = {};
    state.coordinates = [];
  },
  [mTypes.DATA_STORED](state, product) {
    state.product = product.data;
    state.coordinates = [];
    if (state.product.zones) {
      state.product.zones.forEach((el) => {
        if (el.coordinates) {
          state.coordinates.push(el.coordinates);
        }
      });
    }
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/tenants/product.js